export const navLinks = [
  { id: "ranking", label: "热度总榜", icon: "ri-fire-line" },
  { id: "categories", label: "栏目分类", icon: "ri-grid-fill" },
  { id: "tracking", label: "爆点追踪", icon: "ri-focus-3-line" },
  { id: "about", label: "追踪说明", icon: "ri-compass-3-line" },
  { id: "voice", label: "用户口碑", icon: "ri-chat-heart-line" },
  { id: "faq", label: "常见问题", icon: "ri-questionnaire-line" },
];

export const categoryTabs = [
  { key: "all", label: "全部" },
  { key: "ent", label: "娱乐" },
  { key: "variety", label: "综艺影视" },
  { key: "game", label: "电竞游戏" },
  { key: "tech", label: "科技数码" },
  { key: "social", label: "职场社会" },
  { key: "life", label: "生活八卦" },
];

export interface HotItem {
  id: number;
  rank: number;
  title: string;
  category: string;
  tag: string;
  heat: number;
  trend: "up" | "down" | "flat";
  delta: number;
  summary: string;
  burst: boolean;
}

export const rankings: HotItem[] = [
  {
    id: 1, rank: 1,
    title: "一线综艺口碑两极发酵，热梗全网刷屏",
    category: "variety", tag: "综艺影视", heat: 9820, trend: "up", delta: 15,
    summary: "新一期节目名场面被二次创作铺开，观众两极观点持续对冲，话题阅读量在深夜迎来二次高峰。",
    burst: true,
  },
  {
    id: 2, rank: 2,
    title: "顶流团演唱会阵容官宣，粉丝阵营吵翻天",
    category: "ent", tag: "娱乐饭圈", heat: 9650, trend: "up", delta: 9,
    summary: "巡演城市与助演嘉宾名单陆续流出，票务与应援话题带动周边讨论迅速升温，热度一路走高。",
    burst: true,
  },
  {
    id: 3, rank: 3,
    title: "某游戏赛事爆冷出局，弹幕与复盘贴双爆",
    category: "game", tag: "电竞游戏", heat: 9410, trend: "flat", delta: 1,
    summary: "夺冠热门意外一轮游引发大范围复盘，教练组与选手状态成为玩家争论焦点，多个复盘串烧登上热门。",
    burst: true,
  },
  {
    id: 4, rank: 4,
    title: "老牌综艺停播消息传开，情怀党集体回忆杀",
    category: "variety", tag: "综艺影视", heat: 9080, trend: "up", delta: 21,
    summary: "停播传闻刷屏后，多年老粉开始回顾经典名场面，官微评论区被“不要停播”刷到置顶。",
    burst: false,
  },
  {
    id: 5, rank: 5,
    title: "新旗舰机发布会前夜，参数与定价大猜想",
    category: "tech", tag: "科技数码", heat: 8760, trend: "down", delta: 6,
    summary: "外观渲染图与配置清单持续流出，粉丝和测评人围绕定价与影像能力展开你来我往的讨论。",
    burst: false,
  },
  {
    id: 6, rank: 6,
    title: "选秀节目翻红选手首度同台，陈年旧料被扒",
    category: "ent", tag: "娱乐饭圈", heat: 8510, trend: "up", delta: 12,
    summary: "两位早年选手同台引发考古，陈年节目画面与幕后花絮被重新拼接，话题覆盖多代观众。",
    burst: false,
  },
  {
    id: 7, rank: 7,
    title: "职场“拒绝加班”事件刷屏，网友站队两极",
    category: "social", tag: "职场社会", heat: 8230, trend: "flat", delta: 2,
    summary: "一纸离职说明在网络发酵，关于劳资关系与年轻人选择的讨论迅速蔓延到多个职场社群。",
    burst: false,
  },
  {
    id: 8, rank: 8,
    title: "高热度手游联动预告泄漏，二创区瞬间开席",
    category: "game", tag: "电竞游戏", heat: 7900, trend: "down", delta: 4,
    summary: "联动活动画面提前流出，玩家一边拆解福利一边玩梗，二创投稿量在当天达到近期峰值。",
    burst: false,
  },
  {
    id: 9, rank: 9,
    title: "影后新作预告放出，全网“求定档”呼声一片",
    category: "variety", tag: "综艺影视", heat: 7640, trend: "up", delta: 8,
    summary: "一支预告让讨论量直线上升，观众围绕阵容与题材展开脑补，定档话题连续两日留在榜单。",
    burst: false,
  },
  {
    id: 10, rank: 10,
    title: "某社交APP改版争议，旧版党开启联名请愿",
    category: "tech", tag: "科技数码", heat: 7310, trend: "down", delta: 7,
    summary: "新版界面改动引发老用户不满，相关请愿话题快速集结，产品团队回应被反复转发解读。",
    burst: false,
  },
  {
    id: 11, rank: 11,
    title: "健身房“跑路”维权升温，避雷清单被转发疯传",
    category: "life", tag: "生活八卦", heat: 7020, trend: "up", delta: 18,
    summary: "多家门店接连停业后，网友自发整理避雷与维权攻略，实用帖获得远超平均的收藏与转发。",
    burst: false,
  },
  {
    id: 12, rank: 12,
    title: "高校毕业典礼名场面集锦，泪点笑点齐飞",
    category: "life", tag: "生活八卦", heat: 6680, trend: "flat", delta: 0,
    summary: "各校毕业典礼现场画面被汇总，青涩与告别引发全民共鸣，二创内容在朋友圈持续扩散。",
    burst: false,
  },
];

export const categoryCards = [
  { key: "ent", icon: "ri-star-smile-fill", title: "娱乐饭圈", desc: "偶像动态、饭圈事件与粉丝舆论的持续跟进，还原热梗背后的来龙去脉。", count: "1.2k+" },
  { key: "variety", icon: "ri-clapperboard-fill", title: "综艺影视", desc: "节目口碑、名场面与影视作品的热度观察，紧跟定档、开播与收官节点。", count: "860+" },
  { key: "game", icon: "ri-gamepad-fill", title: "电竞游戏", desc: "赛事爆冷、版本更迭与厂商动向，吃透竞技圈与玩家社区的最新爆点。", count: "740+" },
  { key: "tech", icon: "ri-cpu-fill", title: "科技数码", desc: "发布会前夜猜想、产品争议与品牌舆论，捕捉科技圈的热搜密码。", count: "530+" },
  { key: "social", icon: "ri-briefcase-4-fill", title: "职场社会", desc: "职场话题与社会现象，梳理引发全民共鸣的讨论脉络与观点交锋。", count: "410+" },
  { key: "life", icon: "ri-cup-fill", title: "生活八卦", desc: "街头巷尾的生活热点与消费避雷，轻松吃瓜也能吃出实用价值。", count: "680+" },
];

export interface FeedItem {
  id: number;
  title: string;
  time: string;
  stage: string;
  status: "heating" | "watching" | "recap" | "cleared";
  nodes: number;
  brief: string;
}

export const feedStatusMap = {
  heating: { label: "发酵中", color: "bg-primary-500" },
  watching: { label: "持续关注", color: "bg-accent-500" },
  recap: { label: "事件复盘", color: "bg-secondary-500" },
  cleared: { label: "已澄清", color: "bg-foreground-400" },
};

export const feed: FeedItem[] = [
  {
    id: 1, title: "综艺名场面为何能在三天内全网刷屏？", time: "今日 14:20", stage: "第 4 节点",
    status: "heating", nodes: 4,
    brief: "从切片二次创作到两极观点对冲，拆解一条热梗从节目内走向全网的完整扩散路径。",
  },
  {
    id: 2, title: "顶流巡演官宣后的 24 小时发生了什么", time: "今日 11:05", stage: "第 3 节点",
    status: "heating", nodes: 3,
    brief: "官宣、阵容猜测、应援号召与争议逐层叠加，整理事件发酵的关键时间轴。",
  },
  {
    id: 3, title: "赛事爆冷出局，弹幕与复盘帖在吵什么", time: "昨日 21:40", stage: "第 3 节点",
    status: "watching", nodes: 3,
    brief: "粉丝、解说与战术党对出局原因各执一词，持续收录主流观点与关键证据。",
  },
  {
    id: 4, title: "停播传闻下，情怀党与路人如何看待这档节目", time: "昨日 17:30", stage: "第 2 节点",
    status: "watching", nodes: 2,
    brief: "官微尚未正面回应，我们先汇总评论区风向与历年口碑复盘，等待后续官方消息。",
  },
  {
    id: 5, title: "年度五大出圈热梗复盘：它们是怎么火的", time: "09-04", stage: "收官复盘",
    status: "recap", nodes: 5,
    brief: "从话题起源到二创井喷再到全网玩梗，一份帮助你理解“热梗经济”的完整复盘。",
  },
  {
    id: 6, title: "健身房维权避雷指南：从曝光到落地", time: "09-04", stage: "复盘",
    status: "recap", nodes: 4,
    brief: "整理网友整理的避雷清单与维权流程，把情绪讨论沉淀为可操作的行动参考。",
  },
  {
    id: 7, title: "旧版 APP 改版争议后续：产品团队已回应", time: "09-03", stage: "澄清更新",
    status: "cleared", nodes: 3,
    brief: "官方就界面调整作出说明并预告部分功能回退，争议热度随之回落并进入收尾。",
  },
  {
    id: 8, title: "网络传闻澄清速报：多平台同步辟谣整理", time: "09-02", stage: "澄清",
    status: "cleared", nodes: 2,
    brief: "对流传的多条未经证实说法进行逐条核对，汇总权威信源结论，避免信息二次误读。",
  },
];

export const faqs = [
  {
    q: "9看料的热度排行榜是怎么来的？",
    a: "榜单综合话题在公开社交平台与搜索热点的提及频次、讨论增量、扩散速度等多维信号，按当日热度加权排序生成。数值会随新增讨论持续刷新，反映的是“当下大家最关心什么”，而非固定不变的结论。",
  },
  {
    q: "为什么同一个话题的热度会忽高忽低？",
    a: "热度主要取决于单位时间内的讨论增量。新爆料、新反转或当事人公开回应，都会带来一波讨论脉冲；当热潮过去、话题转向或后续无新信息时热度自然回落。这正是事件发酵的正常节奏，我们会在时间线上标注每个关键节点。",
  },
  {
    q: "榜上的瓜信息可信吗，会不会是谣言？",
    a: "9看料仅对公开可见的信息做整理与趋势呈现，不代表对内容本身的证实。凡存疑信息我们都会标注“发酵中”或“待核实”，并引导以官方声明与权威信源为准。也提醒大家：未经证实的单方说法先别急着下结论，多看、多等、多核对。",
  },
  {
    q: "榜单上的内容如果有误，可以反馈吗？",
    a: "当然可以。页面底部的投稿联系表单随时开放，提交纠错或补充信息即可。我们会优先核对公开信源，对确有问题的条目进行修正、补充标注或下架，让榜单尽量干净可信。",
  },
  {
    q: "我可以在这里投稿提供线索吗？",
    a: "可以。在投稿表单中填写话题标题、简要经过，以及可公开核验的信源链接即可。编辑部审核并整理后，若话题具备关注度与传播性，将有机会进入追踪时间线甚至热度榜单。",
  },
  {
    q: "9看料会追更某条话题的后续进展吗？",
    a: "会。凡是进入追踪体系的话题，我们都会按发酵节点持续更新，并标注当前状态——发酵中、持续关注、事件复盘或已澄清，帮你沿着时间线一路跟完整个来龙去脉，不用满网翻帖拼拼凑凑。",
  },
];

export const testimonials = [
  { name: "小瓜本瓜", role: "综艺考古爱好者", text: "平时刷资讯最怕看一半没下文，这里把一条瓜的发酵节点整理得清清楚楚，状态一栏就能知道现在吵到哪一步了，太省心。", icon: "ri-emotion-happy-fill" },
  { name: "电竞老张", role: "赛事复盘党", text: "比赛爆冷当晚就想找人聊，榜单刷新很及时，复盘帖观点也比较全，热度和走向一眼能看懂，做弹幕冲浪前的功课够用。", icon: "ri-gamepad-fill" },
  { name: "橘子不是柚子", role: "科技发布会钉子户", text: "发布会前夜基本都是在这猜参数找乐子，官方消息出来热度就会回落，机制很真实。偶尔也给纠错帖投过稿，处理得挺快。", icon: "ri-flashlight-fill" },
  { name: "路过的吃瓜群众", role: "午休刷榜常客", text: "午休点开热度总榜扫一眼，今天大家在追什么心里就有数了，跟同事聊天不会接不上梗，追更也追得明明白白。", icon: "ri-cup-fill" },
];

export const brandStats = [
  { value: "3200+", label: "累计追踪话题" },
  { value: "860万", label: "累计热度采集" },
  { value: "98.6%", label: "公开信源核对率" },
  { value: "7×24h", label: "持续更新不间断" },
];

export const methodSteps = [
  { icon: "ri-radar-fill", step: "01", title: "全网信号捕捉", desc: "在公开社交与搜索热点中抓取高频话题信号，圈定当下最有讨论价值的候选瓜点。" },
  { icon: "ri-node-tree", step: "02", title: "脉络拆解分档", desc: "按六大栏目归类，建立话题档案，让每条大瓜都有清晰可查的身份与来路。" },
  { icon: "ri-temp-hot-line", step: "03", title: "热度多维计算", desc: "综合提及频次、讨论增量与扩散速度计算热度，形成可排序、可回看的榜单数值。" },
  { icon: "ri-time-line", step: "04", title: "发酵状态跟进", desc: "对高关注话题持续追更，标注发酵中、持续关注、事件复盘与已澄清四类状态。" },
  { icon: "ri-sparkling-line", step: "05", title: "信源交叉核对", desc: "尽量以官方声明与权威信源为准，对存疑信息标注待核实，发现偏差及时修正或下架。" },
  { icon: "ri-exchange-funds-line", step: "06", title: "榜单每日刷新", desc: "数值随讨论实时滚动，隔天生成新的热度排行，让你每天都有最新的追更坐标。" },
];

export const principles = [
  { icon: "ri-eye-2-fill", title: "只做呈现，不代下结论", desc: "我们整理公开可见的信息与观点，还原讨论走向，是否采信由你自己判断。" },
  { icon: "ri-quill-pen-fill", title: "存疑即标注", desc: "未经证实的说法会明确打上“待核实 / 发酵中”，绝不把流言包装成定论。" },
  { icon: "ri-government-fill", title: "以权威信源为锚", desc: "涉及是非对错的话题，优先采信官方声明与权威渠道，避免以讹传讹。" },
  { icon: "ri-group-fill", title: "平等收录不同声音", desc: "对观点对峙的话题保留多方视角，不因单方面热度高就选择性偏向。" },
];